import PropTypes from 'prop-types';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle
import { mmyUrlFromVehicle } from 'components/Comparison';
// eslint-disable-next-line import/no-cycle
import {
  LineItemContainer,
  LineItem,
  LineItemValue,
} from 'components/Comparison/LineItems';
import { determineLowestNumberFactory } from 'components/Comparison/LineItems/helpers';

export default function PricingAndAvailability({ listings, comparison }) {
  const { t } = useTranslation();

  function availableListingsLink(vehicle) {
    return (
      <a
        href={mmyUrlFromVehicle(vehicle)}
        dangerouslySetInnerHTML={{
          __html: t('comparison.listings.viewAvailable'),
        }}
      />
    );
  }

  function formatAveragePrice(vehicle) {
    if (vehicle.average_price) {
      return numeral(vehicle.average_price).format('$0,0');
    }
    return 'N/A';
  }

  function formatAveragePriceCount(vehicle) {
    if (vehicle.average_price_count) {
      return t('comparison.listings.basedOn', {
        count: vehicle.average_price_count,
      });
    }
    return null;
  }

  function getListingCountForVehicle(vehicle) {
    const { vehicle1 } = comparison;

    if (!listings) {
      return null;
    }

    let vehicleKey;

    if (
      vehicle1.year === vehicle.year &&
      vehicle1.make === vehicle.make &&
      vehicle1.model === vehicle.model
    ) {
      vehicleKey = 'vehicle1';
    } else {
      vehicleKey = 'vehicle2';
    }

    if (listings[vehicleKey]) {
      return listings[vehicleKey].total_count;
    }
    return null;
  }

  function formatListingCount(vehicle) {
    const listingCount = getListingCountForVehicle(vehicle);
    if (listingCount) {
      return t('comparison.listings.count', { count: listingCount });
    }
    return null;
  }

  if (!listings.vehicle1 && !listings.vehicle2) {
    return null;
  }

  return (
    <LineItemContainer
      title={t('comparison.lineItems.pricingAndAvailability')}
      comparison={comparison}
    >
      <LineItem title={t('comparison.lineItems.averagePrice')}>
        <LineItemValue
          comparison={comparison}
          getValue={formatAveragePrice}
          getSubText={formatAveragePriceCount}
          determineWinner={determineLowestNumberFactory('average_price')}
        />
      </LineItem>
      <LineItem title={t('comparison.lineItems.availability')}>
        <LineItemValue
          comparison={comparison}
          getValue={formatListingCount}
          getSubText={availableListingsLink}
          determineWinner={() => null}
        />
      </LineItem>
    </LineItemContainer>
  );
}

PricingAndAvailability.propTypes = {
  listings: PropTypes.object,
  comparison: PropTypes.object,
};
